import { useParams } from "react-router-dom";
import Column0Table from "./Column0Table";
import Column1Table from "./Column1Table";
import Column2Table from "./Column2Table";
import styles from "./index.module.less";

function ReceiveAnnouncement() {
  const { column = 0 } = useParams();
  let Component;
  if (column === "0") {
    Component = Column0Table;
  } else if (column === "1") {
    Component = Column1Table;
  } else {
    Component = Column2Table;
  }
  return (
    <div className={styles.draftAnnouncement}>
      <Component column={column} />
    </div>
  );
}

export default ReceiveAnnouncement;
